import React from 'react';
import styled from "styled-components";

const SGrammarAdjetivos = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarAdjetivos = () => {
  return (
  <SGrammarAdjetivos>
<h5>Adjetivos - Przymiotniki</h5>

<p>W języku hiszpańskim przymiotnik musi się zgadzać rodzajem i liczbą z rzeczownikiem, który określa. Przymiotniki rodzaju męskiego zakończone na <i><nobr>-o</nobr></i> tworzą odpowiednik w rodzaju żeńskim przez zamianę końcówki na <i>-a</i>:<br/>
<li><b>bonito</b> - <b>bonita</b> (ładny - ładna)</li>
<li><b>polaco</b> - <b>polaca</b> (polski - polska)</li>
</p>
<p>Przymiotniki zakończone na <i>-ista</i> oraz <i>-e</i> i <i>-z</i> zachowują tę samą formę w obu rodzajach:<br/>
<li><b>egoista</b>, <b>comunista</b>, <b>verde</b> (zielony, zielona), <b>feliz</b> (szczęśliwy, szczęśliwa)</li>
</p>
<p>Do przymiotników zakończonych w rodzaju męskim na <i>-án</i>, <i>-ón</i>, <i>-ín</i> oraz na <i><nobr>-or</nobr></i> w rodzaju żeńskim dodajemy <i>-a</i> (zanika akcent graficzny):<br/>
<li><b>charlatán</b> - <b>charlatana</b> (gadatliwy - gadatliwa)</li>
<li><b>trabajador</b> - <b>trabajadora</b> (pracowity - pracowita)</li>
</p>
<p>Do przymiotników oznaczających narodowości i zakończonych na spółgłoskę w rodzaju męskim, w rodzaju żeńskim dodajemy <i>-a</i>:<br/>
<li><b>inglés</b> - <b>inglesa</b></li>
<li><b>andaluz</b> - <b>andaluza</b></li>
</p>
<p>Liczbę mnogą tworzymy przez dodanie <i>-s</i> do samogłoski lub <i>-es</i> do spółgłoski:<br/>
<li><b>italiano</b> - <b>italianos</b></li>
<li><b>feliz</b> - <b>felices</b></li>
</p>
<p>Przymiotnik może pojawić się przed lub za rzeczownikiem. W większości przypadków znajduje się po rzeczowniku i stanowi dodatkową o nim informację:<br/>
<i>He leído un libro muy interesante</i> - Przeczytałem bardzo ciekawą książkę.<br/>
<i>El equipo barcelonés ganó el partido</i> - Drużyna Barcelony wygrała mecz.
</p>
<p>Istnieje kilka przymiotników, które przed określonymi rzeczownikami tracą ostatnią samogłoskę lub sylabę:<br/>
<li><b>bueno</b> (<i>Hoy hace buen tiempo</i> - Dzisiaj jest ładna pogoda)</li>
<li><b>malo</b> (<i>Carmen está de mal humor</i> - Carmen jest w złym humorze)</li>
<li><b>grande</b> (<i>Esto es un gran problema</i> - To jest duży problem)</li>
</p>
<p>Stopniowanie przymiotników jest poza czterema wyjątkami regularne. Zaimki <b>más</b> (bardziej) i <b>menos</b> (mniej) tworzą stopień wyższy:<br/>
<i>Juan es más alto que su hermano</i> - Juan jest wyższy niż jego brat
</p>
<p>Stopień najwyższy tworzy się dodając do stopnia wyższego rodzajnik określony:<br/>
<i>Juan es el más alto de la clase</i> - Juan jest najwyższy z klasy<br/>
</p>
<p>Przymiotniki o nieregularnym stopniowaniu:
<table>
<tr><td><b>bueno</b> (dobry)</td><td><b>mejor</b> (lepszy)</td><td><b>el mejor</b> (najlepszy)</td></tr>
<tr><td><b>malo</b> (zły)</td><td><b>peor</b> (gorszy)</td><td><b>el peor</b> (najgorszy)</td></tr>
<tr><td><b>grande</b> (duży)</td><td><b>mayor</b> (większy)</td><td><b>el mayor</b> (największy)</td></tr>
<tr><td><b>pequeno</b> (mały)</td><td><b>menor</b> (mniejszy)</td><td><b>el menor</b> (najmniejszy)</td></tr>
</table>
</p>
<p>Istnieje również forma <i>superlativo</i> (<b>guapísimo</b> - bardzo ładny).</p>
  </SGrammarAdjetivos>
  );
};

export default GrammarAdjetivos;